/// <reference path="../../../data/src/raw.d.ts" />

import zhSource from "../../../../data/i18n/zh.jsonc?raw";
import enSource from "../../../../data/i18n/en.jsonc?raw";
import { parseJsonc } from "@bastion/data";

/** Loaded zh translations at runtime. */
export const zh = parseJsonc(zhSource, "data/i18n/zh.jsonc") as Record<string, string | string[]>;
/** Loaded en translations at runtime. */
export const en = parseJsonc(enSource, "data/i18n/en.jsonc") as Record<string, string | string[]>;
